import { userConstants } from '../constants/user.constants';

let stateDefault = {};

if(localStorage.getItem('me'))  {
  stateDefault.me = JSON.parse(localStorage.getItem('me'));
}

export function users(state = stateDefault, action) {
  switch (action.type) {
    case userConstants.LOGOUT:
      return {};
    case userConstants.CREATE_REQUEST:
    case userConstants.UPDATE_REQUEST:  
    case userConstants.REMOVE_REQUEST:  
    return {
      ...state,
      loading: true,
      ...action.users
    };
    case userConstants.CREATE_GROUP_REQUEST:
    case userConstants.UPDATE_GROUP_REQUEST:  
    case userConstants.REMOVE_GROUP_REQUEST:  
    return {
      ...state,
      loading: true,
      ...action.group
    };
    case userConstants.FETCH_REQUEST:
    case userConstants.MANAGERS_REQUEST:
    case userConstants.SUBORDINATES_REQUEST:
      return {
        ...state,
        loading: true
      };
    case userConstants.GET_SUCCESS:
      return {
        ...state,
        loading: false,
        item: action.user
      };
    case userConstants.GET_GROUP_SUCCESS:
      return {
        ...state,
        loading: false,
        itemGroup: action.group
      };
    case userConstants.ME_SUCCESS:       
      return {
        ...state,
        loading: false,
        me: action.me
      };
    case userConstants.STATUS_SUCCESS:       
      return {
        ...state,
        loading: false,
        status: action.status
      };
    case userConstants.FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        ...action.users
      };    
    case userConstants.FETCH_GROUP_SUCCESS:
      return {
        ...state,
        loading: false,
        groups: action.groups
      };    
    case userConstants.SUBORDINATES_SUCCESS:
        return {
          ...state,
          loading: false,
          subordinates: action.subordinates
        };    
    case userConstants.MANAGERS_SUCCESS:
        return {
          ...state,
          loading: false,
          managers: action.managers
        };    
    case userConstants.CREATE_SUCCESS:
    case userConstants.UPDATE_SUCCESS:  
    case userConstants.REMOVE_SUCCESS:  
    return {
      ...state,
      loading: false
    };
    case userConstants.ME_FAILURE:
    case userConstants.GET_FAILURE:
    case userConstants.UPDATE_FAILURE:
    case userConstants.REMOVE_FAILURE:
    case userConstants.FETCH_FAILURE:
    case userConstants.SUBORDINATES_FAILURE:
    case userConstants.MANAGERS_FAILURE:      
    case userConstants.STATUS_FAILURE:      
      return {
        ...state,
        loading: false,
        error: action.error
      };
    default:
      return state
  }
}
